<div id="me-dynamic-report-sub-cluster" class="me-dynamic-report-sub-cluster" *ngIf="activeSubCluster">
    <svg viewBox="0 0 1324 1278" fill="none" class="background">
        <path id="path"
              d="M1071.43 116.387C988.606 34.6552 861.456 18.1592 744.842 17.2143C627.112 16.071 516.88 53.6525 413.837 110.35C296.583 174.65 171.909 239.193 117.95 360.681C61.779 486.241 68.4795 637.573 123.834 763.636C176.707 884.23 300.086 947.465 408.178 1023.62C515.511 1099.45 613.195 1203.53 744.842 1201.77C874.921 1200 972.826 1094.7 1073.58 1012.78C1168.36 935.707 1288.79 864.874 1307.05 744.652C1324.94 627.342 1203.35 539.828 1161.61 428.534C1122.61 324.552 1150.66 194.574 1071.43 116.387Z"
              attr.fill="{{pageColor}}">
        </path>
        <path opacity="0.32"
              d="M821.924 1262.49C934.425 1231.94 1012.35 1130.55 1071.48 1030.47C1131.34 929.529 1153.76 815.689 1155.97 698.49C1158.67 565.237 1164.87 425.463 1086.17 318.193C1005.05 206.978 870.066 137.09 732.738 121.789C601.409 107.082 484.717 181.849 364.43 236.975C244.805 291.608 105.437 323.799 41.1476 438.195C-22.3554 551.24 20.2819 688.31 41.1645 816.146C60.8091 936.404 62.2026 1075.67 157.642 1151.53C250.737 1225.6 387.651 1164.52 505.326 1184.17C615.269 1202.54 714.299 1291.71 821.924 1262.49Z"
              attr.fill="{{pageColor}}">
        </path>
    </svg>
    <div class="me-dynamic-report-sub-cluster--image"
         *ngIf="activeSubCluster.image.filename && activeSubCluster.image.filename != ''">
        <img src="{{activeSubCluster.image.filename}}"/>
    </div>
    <div class="container">
        <div class="row">
            <div class="col-xs-12 me-dynamic-report-sub-cluster--overview">
                <div class="row">
                    <div class="col-xs-12">
                        <div class="me-dynamic-report-sub-cluster--back_btn">
                            <a class="btn btn-link btn-icon btn-icon--left btn-back btn--secondary "
                               [routerLink]="['/me/' + this.url]">
                                {{ 'back' | translate }}
                            </a>
                        </div>
                    </div>
                    <div class="col-sm-6 col-xs-12">
                        <div class="me-dynamic-report-sub-cluster--content">
                            <div class="me-dynamic-report-sub-cluster--content--header">
                                {{activeSubCluster.name}}
                            </div>
                            <div *ngIf="!voiceUrl" [attr.tabindex]="0" role="button" [attr.aria-label]="'Listen to the report' | translate"
                                 class="me-dynamic-report-sub-cluster--content--audio" (click)="getSpeech()" (keyup.enter)="getSpeech()">
                                <div class="audio-block">
                                    <i class="fas fa-play"></i>
                                </div>
                                <div>{{ 'Listen to the report' | translate }}</div>
                            </div>
                            <div *ngIf="voiceUrl" class="me-dynamic-report-sub-cluster--content--audio">
                                <audio #audioOption controls>
                                    <source src="{{voiceUrl}}" type="audio/mpeg">
                                    {{ 'Your browser does not support the audio element.' | translate }}
                                </audio>
                            </div>
                            <div class="me-dynamic-report-sub-cluster--content--description"
                                 [innerHTML]="activeSubCluster.description | storyblokRichtext">
                            </div>
                        </div>
                    </div>
        
                    <div class="col-xs-12" *ngIf="activeSubCluster.prevalence && activeSubCluster.prevalence != ''">
                        <div class="me-dynamic-report-sub-cluster--percent">
                            {{ 'Frequency among our users' | translate}}
                            <div class="me-dynamic-report-sub-cluster--percent--bar">
                                <div class="me-dynamic-report-sub-cluster--percent--bar--container">
                                    <div class="me-dynamic-report-sub-cluster--percent--bar--container--inner"
                                         [@fillAnimation]="{value: animationFilled, params : {percent: activeSubCluster.prevalence}}"></div>
                                </div>
                                <div>
                                    {{activeSubCluster.prevalence}}%
                                </div>
                            </div>
                        </div>
                    </div>
        
                    <div class="col-xs-12 mt-2">
                        <hr/>
                    </div>
                </div>
            </div>

            <div class="col-xs-12 me-dynamic-report-sub-cluster--feeling" *ngFor="let feeling of feelingCluster">
                <div class="row">
                    <div class="col-xs-12">
                        <div class="me-dynamic-report-sub-cluster--feeling--header">
                            {{feeling.name}}
                        </div>
                        <div class="me-dynamic-report-sub-cluster--feeling--description"
                             [innerHTML]="feeling.description | storyblokRichtext"></div>
                        <div class="me-dynamic-report-sub-cluster--feeling--rating">
                            <div>{{ 'Intensity of feelings' | translate }}</div>
                            <div class="me-dynamic-report-sub-cluster--feeling--rating--box">
                                <div class="me-dynamic-report-sub-cluster--feeling--rating--box--inner"
                                     *ngFor="let _ of [].constructor(10); let i = index"
                                     [style.background-color]="pageColor"
                                     [class.active]="((i + 1) * 10) <= feeling.rating">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-12 col-sm-6 mt-1" *ngFor="let article of feeling.articles">
                        <div tabindex="0" class="me-dynamic-report-sub-cluster--article">
                            <div class="me-dynamic-report-sub-cluster--article--image">
                                <img src="{{article.content.image.filename}}"/>
                            </div>
                            <div class="me-dynamic-report-sub-cluster--article--content">
                                <div class="me-dynamic-report-sub-cluster--article--content--header">
                                    {{article.content.headline}}
                                </div>
                                <div class="me-dynamic-report-sub-cluster--article--content--summary">
                                    <div *ngIf="article.content"
                                         class="me-banners--card__content"
                                         [innerHTML]="article.content.content | storyblokRichtext">
                                    </div>
                                </div>
                                <div class="me-dynamic-report-sub-cluster--article--content--more"
                                     [routerLink]="['/me/article/' + article.slug]" (keyup.enter)="openDetail(article)">
                                    <div class="me-dynamic-report-sub-cluster--article--content--more--icon">
                                        <i class="fas fa-chevron-right"></i>
                                    </div>
                                    {{ 'Read more' | translate}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="me-dynamic-report-sub-cluster--btn">
            <button class="btn btn-link btn-icon btn-icon--left btn--secondary " (click)="toTop()">
                <i class="far fa-arrow-up"></i>
                {{ 'Back to top' | translate }}
            </button>
        </div>
    </div>
</div>